export const palettes: IPalettes = {
  '1': {
    id: '1',
    name: 'Salamandra Metalic',
    materials: {
      '0': {
        id: '',
        tint: '#6B6B6B',
        metalness: 0,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 0,
      },
      1: {
        id: '',
        tint: '#CFCFCF',
        metalness: 1,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 0,
      },
      2: {
        id: '',
        tint: '#FF9C57',
        metalness: 1,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 0,
      },
      3: {
        id: '',
        tint: '#FF3751',
        metalness: 1,
        roughness: 0.45,
        specular: 0.5,
        emission: 0,
        transparency: 0,
      },
    },
  },
};
